export default __webpack_public_path__ + "static/media/our-process-05.dac6285b.jpg";